import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';

const FamiliasSidebar = ({ onOptionChange }) => {
    const items = [
        {
            label: 'Criar',
            icon: 'pi pi-plus',
            command: () => onOptionChange('criar')
        },
        {
            label: 'Integrar',
            icon: 'pi pi-link',
            command: () => onOptionChange('integrar')
        }
    ];

    return (
        <div className="p-3">
            <PanelMenu model={items} style={{ width: '100%' }} />
        </div>
    );
};

export default FamiliasSidebar;
